import { rem } from "polished";
import styled from "styled-components";
import { breakpoints } from "styles";

const TEXT_CONTAINER_HEIGHT = `${590 / 2.53}px`;

export const LeadGenerationSectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: radial-gradient(
    circle,
    rgba(21, 69, 211, 0.7) 0%,
    rgba(26, 88, 241, 1) 30%,
    rgba(25, 72, 205, 1) 100%
  );
  overflow: hidden;
`;

export const LeadGenerationSectionContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 1280px;
  overflow: hidden;
  gap: ${rem(32)};
  justify-content: center;
  align-items: center;
  padding-left: 10%;
  padding-right: 10%;
  @media ${breakpoints.mobile} {
    flex-direction: column;
    padding-bottom: 16px;
    width: 100%;
    max-width: none;
    gap: 0px;
    align-items: center;
  }
`;

export const LeadGenerationImgWrapper = styled.div`
  width: 100%;
  height: 100%;
  @media ${breakpoints.mobile} {
    max-width: 100%;
  }
`;

export const LeadGenerationTextWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 12px;
  position: relative;
  padding: ${rem(48)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: fit-content;
  max-width: 590px;
  height: calc(590px / 3);
  margin: 27px 0px 27px 0px;
  @media ${breakpoints.mobile} {
    padding: 0px 24px 0px 24px;
    box-sizing: border-box;
    width: 100%;
    margin: 0px;
    height: 300px;
  }
  @media ${breakpoints.laptop} {
    flex-basis: 45%;
  }
`;

export const SpacerForAbsolute = styled.div<MainContentProps>`
  ${({ page }) =>
    page === "bimbelPage"
      ? `
      @media ${breakpoints.mobile} {
      height: ${TEXT_CONTAINER_HEIGHT};
      display: block;
  }
  `
      : ""}
`;

interface MainContentProps {
  page: string;
}

export const MainContent = styled.div<MainContentProps>`
  ${({ page }) =>
    page === "bimbelPage"
      ? `
    @media ${breakpoints.mobile} {
      position: absolute;
      top: calc(68vw);
      display: flex;
      justify-content: center;
      align-items: center;
    }
  `
      : ""}
`;

export const LeadGenerationTextContainer = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  min-width: fit-content;
  width: 590px;
  height: ${TEXT_CONTAINER_HEIGHT};
  box-sizing: border-box;
  margin-top: 50px;
  margin-bottom: 50px;
  @media ${breakpoints.mobile} {
    width: 100%;
    justify-content: flex-start;
    text-align: center;
    gap: 0px;
  }
`;

export const LeadGenerationSubheading = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  line-height: 36px;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  color: ${({ theme }) => theme.colors.black["100"]};
  margin: 0;
  @media ${breakpoints.mobile} {
    max-width: 100%;
    justify-content: flex-start;
    text-align: center;
    gap: 0px;
    font-size: ${({ theme }) => theme.fontSizes.lg};
  }
`;

export const LeadGenerationHeading = styled.div`
  font-size: ${({ theme }) => theme.fontSizes["5xl"]};
  color: ${({ theme }) => theme.colors.blue["800"]};
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  line-height: 58px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  white-space: nowrap;
  text-shadow: 3px 3px 4px rgba(0, 18, 65, 0.14);
  @media ${breakpoints.mobile} {
    width: 100%;
    justify-content: flex-start;
    text-align: center;
    gap: 0px;
    font-size: ${rem(28)};
    line-height: 36px;
  }
`;

export const LeadGenerationHeadingSubline = styled.span`
  display: block;
  font-size: ${rem(32)};
  line-height: 46px;
  @media ${breakpoints.mobile} {
    font-size: ${rem(22)};
    line-height: 32px;
  }
`;

export const LeadGenerationPriceButtonWrapper = styled.div`
  @media ${breakpoints.mobile} {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
  }
`;

export const LeadGenerationTagContainer = styled.div`
  display: flex;
  justify-content: left;
  min-width: fit-content;
  margin-top: 5px;
  flex-direction: row;
  gap: 8px;
  @media ${breakpoints.mobile} {
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }
`;

export const LeadGenerationTag = styled.div`
  padding: 6px 11px;
  color: ${({ theme }) => theme.colors.brand[600]};
  background-color: ${({ theme }) => theme.colors.neutral[100]};
  font-weight: 700;
  min-width: fit-content;
  border-radius: 54px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.md};
`;
export const Tag1 = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  @media ${breakpoints.mobile} {
    justify-content: center;
  }
`;
export const Tag2 = styled.div`
  display: flex;
  justify-content: center;
  @media ${breakpoints.mobile} {
    justify-content: center;
  }
`;
